import * as React from 'react';

import { cn } from '../../utils';

export interface StepperProps {
  steps: number;
  activeStep: number;
  className?: string;
}

export const Stepper: React.FC<StepperProps> = ({ steps, activeStep, className }) => {
  return (
    <div className={cn('flex items-center gap-1 w-full py-2', className)}>
      {Array.from({ length: steps }).map((_, idx) => (
        <div
          className={cn('w-full h-2 bg-border-weak-hover rounded', {
            'bg-surface': idx <= activeStep,
          })}
          key={idx}
        />
      ))}
    </div>
  );
};
